<!--
  Copyright 2019 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page" *ngIf="survey(); let activeSurvey">
  <ground-survey-header [activeSurvey]="activeSurvey"></ground-survey-header>
  <div class="page-content">
    <ground-side-panel
      [activeSurvey]="activeSurvey"
      [lois]="lois()"
    ></ground-side-panel>
    <ground-secondary-side-panel
      [activeSurvey]="activeSurvey"
      [lois]="lois()"
    ></ground-secondary-side-panel>
    <ground-map [activeSurvey]="activeSurvey" [lois]="lois()"></ground-map>
  </div>
</div>

<div *ngIf="!survey()" class="progress-spinner">
  <mat-spinner mode="indeterminate"></mat-spinner>
</div>
